import React, { useState } from "react";
import Tabs from "../Tabs/Tabs";
import "./CardCharts.scss";

const CardCharts = ({
    title,
    subtitle,
    data,
    percentage = true,
    showTabs = true,
    children,
}) => {
    const [activeTab, setActiveTab] = useState("Semana");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const currentMetrics = data?.metrics?.[activeTab] || {};
    const { amount, percentageValue, percentageText } = currentMetrics;

    const isNegative = percentageValue < 0;

    const hasMetrics = amount || (percentage && percentageValue !== undefined);
    const showMetricsSection = showTabs && hasMetrics;

    return (
        <div className="card-charts">
            <div className="card-charts__header">
                <div
                    className={`card-charts__info ${
                        !showTabs ? "card-charts__info--no-tabs" : ""
                    }`}
                >
                    <div className="card-charts__text">
                        <h3 className="card-charts__title">{title}</h3>
                        <p className="card-charts__subtitle">{subtitle}</p>
                    </div>

                    {showTabs && <Tabs onTabChange={handleTabChange} />}
                </div>

                {showMetricsSection && (
                    <div className="card-charts__metrics">
                        {amount && (
                            <h2 className="card-charts__amount">{amount}</h2>
                        )}
                        {percentage && percentageValue !== undefined && (
                            <div
                                className={`card-charts__percentage ${
                                    isNegative ? "negative" : "positive"
                                }`}
                            >
                                <span className="card-charts__percentage-icon">
                                    {isNegative ? "↓" : "↑"}
                                </span>
                                {Math.abs(percentageValue)}%
                                <span className="card-charts__percentage-text">
                                    {percentageText}
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className="card-charts__content">
                <div className="card-charts__chart-container">
                    {React.cloneElement(children, {
                        data: data?.chartData,
                        activeTab,
                    })}
                </div>
            </div>
        </div>
    );
};

export default CardCharts;
